export default "__VITE_ASSET__BLGSqHxV__ 720w";